import { all } from 'redux-saga/effects';
import { watchFireSmsCreation, watchLoginRequested  } from '../auth';
import { watchFetchUserDetails, watchEditUserDetails } from '../userDetails';
import { watchGetFetchDealInfo} from '../DealInfo';
import { watchFetchBanks, watchFetchBranch } from '../banks';
import { watchContracts, watchGetNewContractUrl, watchfetchPdfUrlForSignContract, watchFetchTemporalUrlContract } from '../contracts'
import { watchCreateVirtualMember, watchLoginRequestVirtualFlow } from '../../reducers/authVirtualMember'
import { watchBillRegistration } from '../../reducers/billRegistration'

export default function* sagas() {
  yield all([
    watchFetchUserDetails(),
    watchEditUserDetails(),
    watchGetFetchDealInfo(),
    watchfetchPdfUrlForSignContract(),
    watchFetchBanks(), watchFetchBranch(),
    watchFireSmsCreation(), watchContracts(), watchGetNewContractUrl(), watchLoginRequested(), watchLoginRequestVirtualFlow(),
    watchCreateVirtualMember(), watchBillRegistration(), watchFetchTemporalUrlContract()]);
    
}



// WEBPACK FOOTER //
// ./src/reducers/sagas/index.js